import { GlobalStyles } from '@mui/material'; // or '@mui/material'
import { useTheme } from '@rabex-kit/rabex-ui';

export const AppGlobalStyles = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        // WebKit browsers (Chrome, Safari, Edge)
        '*::-webkit-scrollbar': {
          width: 6,
          height: 6,
          background: theme.palette.base[200]
        },
        '*::-webkit-scrollbar-track': {
          background: theme.palette.base[200],
          borderRadius: 16
        },
        '*::-webkit-scrollbar-thumb': {
          background: theme.palette.base[300],
          borderRadius: 16
        }
        // '*::-webkit-scrollbar-thumb:hover': {
        //   background: theme.palette.base[400],
        //   cursor: 'pointer'
        // }
        // Firefox
        // '*': {
        //   scrollbarWidth: 'thin',
        //   scrollbarColor: `${theme.palette.base[300]} ${theme.palette.base[200]}`
        // }
      }}
    />
  );
};
